import React from 'react';
import Navigation from '../components/Navigation';
import UserManager from '../components/UserManager';
import './Users.css';

const Home = () => {
  return (
    <div>
      <Navigation />
      <div className="content">
      <UserManager />
      </div>
    </div>
  );
};

export default Home;
